<div class="container-fluid">
  <h3 class="text-center py-3 arb-large-heading">CAMPER TRAILER SEARCH</h3>
  <div class="row p-3">
    <div class="col-3">
      <label>CUSTOMER / TRAILER SEARCH:</label>
    </div>
      <div class="col-4">
        <pos-app-lib-customer-trailer-search (selectNewCustomerTrailer)="selectCustomerTrailer($event)"></pos-app-lib-customer-trailer-search>
      </div>
  </div>
</div>
